document.addEventListener(
  "DOMContentLoaded",
  function () {
    if (
      document.getElementById(
        "Slide-template--15271230603403__16620877397429f7be-2"
      )
    ) {
      //select reference/parent node
      const paragraphList = document.querySelector(
        "#Slide-template--15271230603403__16620877397429f7be-2 .multicolumn-card__info .rte"
      );

      // create image node
      const checkMark = document.createElement("img");
      const imgURL =
        "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/check-mark-icon.png?v=1663611313";
      checkMark.src = imgURL;
      checkMark.alt = "check mark icon";

      paragraphList.children[0].outerHTML =
        '<div class="customListItem"> <div class="listImg">' +
        checkMark.outerHTML +
        ' </div> <div class="listPara">' +
        paragraphList.children[0].outerHTML +
        "</div> </div>";
      paragraphList.children[1].outerHTML =
        '<div class="customListItem"> <div class="listImg">' +
        checkMark.outerHTML +
        ' </div> <div class="listPara">' +
        paragraphList.children[1].outerHTML +
        "</div> </div>";
      paragraphList.children[2].outerHTML =
        '<div class="customListItem"> <div class="listImg">' +
        checkMark.outerHTML +
        ' </div> <div class="listPara">' +
        paragraphList.children[2].outerHTML +
        "</div> </div>";
    }

    if (
      document.querySelector(
        "#Slide-template--15271230603403__1661827086c8b32e4d-1.slideshow__slide .slideshow__text"
      )
    ) {
      //create image
      const fiveStarIcon = document.createElement("img");
      const iconURL =
        "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/custom-five-star-icon.png?v=1663627092";
      fiveStarIcon.src = iconURL;
      fiveStarIcon.alt = "custom five star icon";

      const slideshowHeader = document.querySelectorAll(
        ".slideshow__slide .banner__heading"
      );

      for (var i = 0; i < slideshowHeader.length; i++) {
        slideshowHeader[i].outerHTML =
          fiveStarIcon.outerHTML + "<br>" + slideshowHeader[i].outerHTML;
      }
    }

    if (
      document.querySelector(
        "#shopify-section-template--15271230603403__166208658339bccfd1 a.link"
      )
    ) {
      const arrowBtn = document.querySelector(
        "#shopify-section-template--15271230603403__166208658339bccfd1 a.link"
      ).outerHTML;

      const noArrowBtn1 = document.querySelector(
        "#shopify-section-template--15271230603403__1661826651e22b152a a.button"
      );
      const noArrowBtn2 = document.querySelector(
        "#shopify-section-template--15271230603403__1661827420d8d1dbc6 a.button"
      );
      const noArrowBtn3 = document.querySelector(
        "#shopify-section-template--15271230603403__1661827634b6362148 a.button"
      );

      noArrowBtn1.outerHTML = arrowBtn;
      noArrowBtn2.outerHTML = arrowBtn;
      noArrowBtn3.outerHTML = arrowBtn;
    }

    if (window.innerWidth <= 750) {
      //homepage
      if (
        document.getElementById(
          "Slider-template--15271230603403__1661827086c8b32e4d"
        )
      ) {
        const diabloImmortalMobileSRC =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Diablo-Immortal-testimonial-mobile-background-image.jpg?v=1663623714";
        const genshinMobileSRC =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Genshin-Impact-testimonial-mobile-background-image.jpg?v=1663623970";
        const punishingMobileSRC =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Punishing-Gray-Raven-testimonial-mobile-background-image.jpg?v=1663624255";

        const slideshowImg = document.querySelectorAll(".slideshow__media img");

        slideshowImg[0].outerHTML =
          '<img src="' + diabloImmortalMobileSRC + '" />';
        slideshowImg[1].outerHTML = '<img src="' + genshinMobileSRC + '" />';
        slideshowImg[2].outerHTML = '<img src="' + punishingMobileSRC + '" />';
      }

      if (
        document.getElementById(
          "shopify-section-template--18080778911883__5742bc20-e39e-4012-85fd-9c733451f944"
        )
      ) {
        const holidayBanner =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-New-Years-banner-mobile.jpg?v=1735663095";
        const accountsForSale =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-accounts-for-sale-Banner-mobile.jpg?v=1743458434";
        const homeMainBanner =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-top-up-services-for-mobile-games-website-banner_f783fcdd-9d59-44bd-a71a-7adf9b58a90b.jpg?v=1680153244";
        const overwatchBanner =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-overwatch-website-banner-mobile.jpg?v=1713159281";
        const fortniteBanner =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-fortnite-website-banner-mobile.jpg?v=1733164084";
        const instantTopUpBanner =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Ad_Instant_TopUp_Services-2.jpg?v=1747715260";

        // const topUpBannerMobile =
        //   "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-top-up-mobile-games-website-banner_dd8f90dd-c102-456e-a0db-69ef0e70ea7e.jpg?v=1680067024";

        const referalBannerMobile =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-get-10-give-10-Banner-squared.jpg?v=1713829281";

        const resourceAccountAd =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Ad_Fresh_Accounts-2-mobile.jpg?v=1747009683";

        const fbBannerMobile =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-exclusive-discounts-and-giveaways-website-banner_2687b241-6305-4ed5-8680-82c8b2b999e0.jpg?v=1680067024";

        const slideshowImg = document.querySelectorAll(".slideshow__media img");

        slideshowImg[0].outerHTML = '<img src="' + instantTopUpBanner + '" />';
        slideshowImg[1].outerHTML = '<img src="' + resourceAccountAd + '" />';
        slideshowImg[2].outerHTML = '<img src="' + accountsForSale + '" />';
        slideshowImg[3].outerHTML = '<img src="' + homeMainBanner + '" />';
        slideshowImg[4].outerHTML = '<img src="' + fortniteBanner + '" />';
      }

      //services page
      if (
        document.getElementById(
          "Slider-template--15274055729291__1661888909fb5b3b2b"
        )
      ) {
        const finalFantasyMobileSRC =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Final-Fantasy-Brave-Exvius-testimonial-mobile-background-image.jpg?v=1663624816";
        const diabloImmortalMobileSRC =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Diablo-Immortal-testimonial-mobile-background-image.jpg?v=1663623714";
        const genshinMobileSRC =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Genshin-Impact-testimonial-mobile-background-image.jpg?v=1663623970";

        const slideshowImg = document.querySelectorAll(".slideshow__media img");

        slideshowImg[0].outerHTML =
          '<img src="' + finalFantasyMobileSRC + '" />';
        slideshowImg[1].outerHTML =
          '<img src="' + diabloImmortalMobileSRC + '" />';
        slideshowImg[2].outerHTML = '<img src="' + genshinMobileSRC + '" />';
      }

      //about page
      if (
        document.getElementById(
          "Slider-template--15274079453323__16618895333054674e"
        )
      ) {
        const finalFantasyMobileSRC =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Final-Fantasy-Brave-Exvius-testimonial-mobile-background-image.jpg?v=1663624816";
        const diabloImmortalMobileSRC =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Diablo-Immortal-testimonial-mobile-background-image.jpg?v=1663623714";
        const punishingMobileSRC =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Punishing-Gray-Raven-testimonial-mobile-background-image.jpg?v=1663624255";

        const slideshowImg = document.querySelectorAll(".slideshow__media img");

        slideshowImg[0].outerHTML = '<img src="' + punishingMobileSRC + '" />';
        slideshowImg[1].outerHTML =
          '<img src="' + finalFantasyMobileSRC + '" />';
        slideshowImg[2].outerHTML =
          '<img src="' + diabloImmortalMobileSRC + '" />';
      }

      //collections page
      if (
        document.getElementById(
          "Slider-template--15271230668939__1661890838ccbb5e09"
        )
      ) {
        const finalFantasyMobileSRC =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Final-Fantasy-Brave-Exvius-testimonial-mobile-background-image.jpg?v=1663624816";
        const genshinMobileSRC =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Genshin-Impact-testimonial-mobile-background-image.jpg?v=1663623970";
        const punishingMobileSRC =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Punishing-Gray-Raven-testimonial-mobile-background-image.jpg?v=1663624255";

        const slideshowImg = document.querySelectorAll(".slideshow__media img");

        slideshowImg[0].outerHTML = '<img src="' + genshinMobileSRC + '" />';
        slideshowImg[1].outerHTML = '<img src="' + punishingMobileSRC + '" />';
        // slideshowImg[2].outerHTML = '<img src="' + finalFantasyMobileSRC + '" />';
      }

      //buy now page
      if (
        document.getElementById(
          "shopify-section-template--18080778944651__slideshow"
        )
      ) {
        const holidayBanner =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-New-Years-banner-mobile.jpg?v=1735663095";
        const fbBannerMobile =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-exclusive-discounts-and-giveaways-website-banner_2687b241-6305-4ed5-8680-82c8b2b999e0.jpg?v=1680067024";
        const fortniteBanner =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-fortnite-website-banner-mobile.jpg?v=1733164084";
        const referalBannerMobile =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-get-10-give-10-Banner-squared.jpg?v=1713829281";
        const instantTopUpBanner =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Ad_Instant_TopUp_Services-2.jpg?v=1747715260";
        const resourceAccountAd =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Ad_Fresh_Accounts-2-mobile.jpg?v=1747009683";

        const slideshowImg = document.querySelectorAll(".slideshow__media img");

        slideshowImg[0].outerHTML = '<img src="' + instantTopUpBanner + '" />';
        slideshowImg[1].outerHTML = '<img src="' + resourceAccountAd + '" />';
        slideshowImg[2].outerHTML = '<img src="' + fbBannerMobile + '" />';
        slideshowImg[3].outerHTML = '<img src="' + fortniteBanner + '" />';
        slideshowImg[4].outerHTML = '<img src="' + referalBannerMobile + '" />';
      }

      //accounts for sale collection page
      if (
        document.getElementById(
          "shopify-section-template--18080778518667__slideshow_t644Yg"
        )
      ) {
        const holidayBanner =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-New-Years-banner-mobile.jpg?v=1735663095";
        const fbBannerMobile =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-exclusive-discounts-and-giveaways-website-banner_2687b241-6305-4ed5-8680-82c8b2b999e0.jpg?v=1680067024";
        const fortniteBanner =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-fortnite-website-banner-mobile.jpg?v=1733164084";
        const referalBannerMobile =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-get-10-give-10-Banner-squared.jpg?v=1713829281";
        const instantTopUpBanner =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Ad_Instant_TopUp_Services-2.jpg?v=1747715260";
        const resourceAccountAd =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Ad_Fresh_Accounts-2-mobile.jpg?v=1747009683";

        const slideshowImg = document.querySelectorAll(".slideshow__media img");

        slideshowImg[0].outerHTML = '<img src="' + instantTopUpBanner + '" />';
        slideshowImg[1].outerHTML = '<img src="' + resourceAccountAd + '" />';
        slideshowImg[2].outerHTML = '<img src="' + fbBannerMobile + '" />';
        slideshowImg[3].outerHTML = '<img src="' + fortniteBanner + '" />';
        slideshowImg[4].outerHTML = '<img src="' + referalBannerMobile + '" />';
      }

      //top up collection page
      if (
        document.getElementById(
          "shopify-section-template--18080778616971__slideshow_tHLxkw"
        )
      ) {
        const holidayBanner =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-New-Years-banner-mobile.jpg?v=1735663095";
        const fbBannerMobile =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-exclusive-discounts-and-giveaways-website-banner_2687b241-6305-4ed5-8680-82c8b2b999e0.jpg?v=1680067024";
        const fortniteBanner =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-fortnite-website-banner-mobile.jpg?v=1733164084";
        const referalBannerMobile =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-get-10-give-10-Banner-squared.jpg?v=1713829281";
        const instantTopUpBanner =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Ad_Instant_TopUp_Services-2.jpg?v=1747715260";
        const resourceAccountAd =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Ad_Fresh_Accounts-2-mobile.jpg?v=1747009683";

        const slideshowImg = document.querySelectorAll(".slideshow__media img");

        slideshowImg[0].outerHTML = '<img src="' + instantTopUpBanner + '" />';
        slideshowImg[1].outerHTML = '<img src="' + resourceAccountAd + '" />';
        slideshowImg[2].outerHTML = '<img src="' + fbBannerMobile + '" />';
        slideshowImg[3].outerHTML = '<img src="' + fortniteBanner + '" />';
        slideshowImg[4].outerHTML = '<img src="' + referalBannerMobile + '" />';
      }

      //loyalty program page
      if (
        document.querySelector(
          "#shopify-section-template--16364472795275__1713755844083193eb"
        )
      ) {
        const loyaltyProgramMobileBanner =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-loyalty-rewards-program-banner-mobile.jpg?v=1713822731";

        const loyaltyProgramBanner = document.querySelectorAll(
          "#shopify-section-template--16364472795275__1713755844083193eb .Joy-Hero-Banner_Image"
        );

        console.dir(loyaltyProgramBanner[0].style.background);

        loyaltyProgramBanner[0].style.background =
          'url("https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-loyalty-rewards-program-banner-mobile.jpg?v=1713824935")';

        // https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-loyalty-rewards-program-banner-mobile.jpg?v=1713822731
      }
    }

    // Order fulfillment  status
    // function updateRemainingTime() {
    //   const now = new Date();
    //   const currentHour = now.getHours();
    //   const currentMinute = now.getMinutes();
    //   const targetHour = 6; // 6 am Pacific Time

    //   if (currentHour >= 2 && currentHour < 6) {
    //     const remainingHours = targetHour - currentHour - 1;
    //     const remainingMinutes = 60 - currentMinute;
    //     document.getElementById(
    //       "remaining-time"
    //     ).textContent = `Order fulfillment starts at 6 AM PST, in about: ${remainingHours} hour(s) ${remainingMinutes} minute(s). Thank you for your patience.`;
    //     document.getElementById("remaining-time").style.color = "green";
    //   } else {
    //     document
    //       .getElementById("order-fulfillment-reminder")
    //       .classList.add("hidden");
    //   }
    // }

    // setInterval(updateRemainingTime, 60000); // Update every minute

    // updateRemainingTime(); // Initial call to update remaining time

    /*
| Add social icons on footer
*/

    // Select the footer social list
    const socialList = document.querySelector("ul.footer__list-social");

    if (socialList) {
      // Create the list item
      const listItem = document.createElement("li");
      listItem.className = "list-social__item";

      // Create the link element
      const discordLink = document.createElement("a");
      discordLink.classList.add("link", "list-social__link");
      discordLink.href = "https://discord.com/invite/jrsgfaxFrn";
      discordLink.target = "_blank";

      // Create the image element
      const discordIcon = document.createElement("img");
      discordIcon.src =
        "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/discord-icon-white.png?v=1739972645";
      discordIcon.alt = "Discord";
      discordIcon.style.width = "20px";
      discordIcon.style.height = "20px";
      discordIcon.style.transition = "opacity";

      // Hover effect: Change image on hover
      const hoverImageSrc =
        "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/discord-icon-green.png?v=1739972710";
      discordLink.addEventListener("mouseover", function () {
        discordIcon.src = hoverImageSrc;
      });
      discordLink.addEventListener("mouseout", function () {
        discordIcon.src =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/discord-icon-white.png?v=1739972645";
      });

      // Append elements
      discordLink.appendChild(discordIcon);
      listItem.appendChild(discordLink);
      socialList.appendChild(listItem);
    } else {
      console.warn("Footer social list not found: Discord icon not added.");
    }

    /*
| Make first slide banner clickable
*/

    //Homepage

    if (
      document.getElementById(
        "Slider-template--18080778911883__5742bc20-e39e-4012-85fd-9c733451f944"
      )
    ) {
      // 1. Select the first slide by ID
      const slide = document.getElementById(
        "Slider-template--18080778911883__5742bc20-e39e-4012-85fd-9c733451f944"
      );

      // 2. Define your URL (placeholder for now)
      const targetUrl = "https://packattackstore.com/pages/instant-top-ups";

      // 3. Make the whole slide look and act clickable
      slide.style.cursor = "pointer";
      slide.addEventListener("click", () => {
        window.location.href = targetUrl;
      });
    }

    //Manual top up page

    if (
      document.getElementById(
        "Slide-template--18080778616971__slideshow_tHLxkw-1"
      )
    ) {
      // 1. Select the first slide by ID
      const slide = document.getElementById(
        "Slide-template--18080778616971__slideshow_tHLxkw-1"
      );

      // 2. Define your URL (placeholder for now)
      const targetUrl = "https://packattackstore.com/pages/instant-top-ups";

      // 3. Make the whole slide look and act clickable
      slide.style.cursor = "pointer";
      slide.addEventListener("click", () => {
        window.location.href = targetUrl;
      });
    }

    //Accounts for sale page

    if (
      document.getElementById(
        "Slide-template--18080778518667__slideshow_t644Yg-1"
      )
    ) {
      // 1. Select the first slide by ID
      const slide = document.getElementById(
        "Slide-template--18080778518667__slideshow_t644Yg-1"
      );

      // 2. Define your URL (placeholder for now)
      const targetUrl = "https://packattackstore.com/pages/instant-top-ups";

      // 3. Make the whole slide look and act clickable
      slide.style.cursor = "pointer";
      slide.addEventListener("click", () => {
        window.location.href = targetUrl;
      });
    }

    //All collections page

    if (document.getElementById("Slider-template--18080778944651__slideshow")) {
      // 1. Select the first slide by ID
      const slide = document.getElementById(
        "Slider-template--18080778944651__slideshow"
      );

      // 2. Define your URL (placeholder for now)
      const targetUrl = "https://packattackstore.com/pages/instant-top-ups";

      // 3. Make the whole slide look and act clickable
      slide.style.cursor = "pointer";
      slide.addEventListener("click", () => {
        window.location.href = targetUrl;
      });
    }

    /*
| Add mobile image to banner on instant top up page
*/

    if (window.innerWidth <= 990) {
      if (
        document.getElementById(
          "Banner-template--18080779075723__image_banner_qAJGnH"
        )
      ) {
        const mobileImageURL =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Ad_Instant_TopUp_Services-2.jpg?v=1747715260";

        const desktopBanner = document.querySelectorAll(
          "#Banner-template--18080779075723__image_banner_qAJGnH img"
        );

        desktopBanner[0].outerHTML = '<img src="' + mobileImageURL + '" />';

        const mobileBanner = document.querySelectorAll(
          "#Banner-template--18080779075723__image_banner_qAJGnH .banner__media"
        );

        mobileBanner[0].style.height = "44rem";
      }
    }

// =========================
// Dropdowns (JSON-powered)
// =========================

// --- 0) Guards
const header = document.querySelector('.header');
const headerWrapper = document.querySelector('.header-wrapper');
if (!header || !headerWrapper) { /* bail if no header */ throw new Error('Header not found'); }

// Ensure the wrapper can anchor the absolute panel
if (getComputedStyle(headerWrapper).position === 'static') {
  headerWrapper.style.position = 'relative';
}

// --- 1) Create the shared panel (3 grids)
const panel = document.createElement('div');
panel.className = 'instant-panel';
panel.style.display = 'none';
panel.style.position = 'absolute';
panel.style.left = '0';
panel.style.width = '100%';
panel.style.zIndex = '999';
panel.innerHTML = `
  <div class="item-grid" style="max-width:1300px; margin:0 auto; padding:22px;">
    <div class="grid-container instant-grid" style="display:none;"></div>
    <div class="grid-container manual-grid" style="display:none;"></div>
    <div class="grid-container accounts-grid" style="display:none;"></div>
  </div>
`;
headerWrapper.appendChild(panel);

const instantGrid = panel.querySelector('.instant-grid');
const manualGrid = panel.querySelector('.manual-grid');
const accountsGrid = panel.querySelector('.accounts-grid');

// --- 2) Read JSON injected by Liquid
function readJson(id) {
  const el = document.getElementById(id);
  if (!el) return [];
  try { return JSON.parse(el.textContent || '[]'); }
  catch { return []; }
}

const instantItems = readJson('instant-topup-data') || [];
const manualItems = readJson('manual-topup-data') || [];
const accountsItems = readJson('accounts-for-sale-data') || [];

// --- 3) Grid builder
function buildGrid(container, items) {
  container.innerHTML = '';
  items
    .slice()
    .sort((a,b)=>(a.title||'').localeCompare(b.title||''))
    .forEach(item => {
      const hasImg = !!item.image;
      const imgTag = hasImg ? `<img src="${item.image}" alt="${item.title||''}" style="width:54px; margin-right:12px;">` : '';
      const cell = document.createElement('div');
      cell.className = 'grid-cell';
      cell.style.display = 'flex';
      cell.style.alignItems = 'center';
      cell.style.justifyContent = 'flex-start';
      cell.innerHTML = `
        <a href="${item.url}" style="flex-shrink:0; ${hasImg ? '' : 'display:none;'}">${imgTag}</a>
        <a href="${item.url}" class="cell-title" style="font-size:14px; text-decoration:none;">${item.title||''}</a>
      `;
      container.appendChild(cell);
    });
}

// --- 4) Find parent triggers
function findMenuTrigger(label) {
  const want = (label||'').trim().toLowerCase();
  const nodes = document.querySelectorAll('nav.header__inline-menu summary, nav.header__inline-menu a');
  for (const el of nodes) {
    const text = (el.querySelector('span')?.textContent || el.textContent || '').trim().toLowerCase();
    if (text === want) return el;
  }
  return null;
}

// --- 5) Desktop behavior
const parents = [
  { label: 'Instant Top-up', grid: instantGrid, items: instantItems, built: false },
  { label: 'Manual Top-up', grid: manualGrid, items: manualItems, built: false },
  { label: 'Accounts for Sale', grid: accountsGrid, items: accountsItems, built: false },
];

function showPanelFor(idx) {
  const p = parents[idx];
  panel.style.top = headerWrapper.offsetHeight + 'px';
  if (!p.built) { buildGrid(p.grid, p.items); p.built = true; }
  parents.forEach((pp, j) => { pp.grid.style.display = (j === idx) ? 'grid' : 'none'; });
  panel.style.display = 'block';
}

let panelHideTimer = null;
panel.addEventListener('mouseenter', () => {
  if (panelHideTimer) { clearTimeout(panelHideTimer); panelHideTimer = null; }
});
panel.addEventListener('mouseleave', () => {
  if (panelHideTimer) clearTimeout(panelHideTimer);
  panelHideTimer = setTimeout(() => { panel.style.display = 'none'; }, 120);
});

parents.forEach((p, idx) => {
  const trigger = findMenuTrigger(p.label);
  if (!trigger) return;
  trigger.addEventListener('mouseenter', () => showPanelFor(idx));
  const details = trigger.closest('details');
  if (details) {
    const summary = details.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', (e) => {
        if (window.innerWidth >= 990) {
          e.preventDefault();
          e.stopPropagation();
          details.open = false;
          showPanelFor(idx);
        }
      });
    }
  }
});

const headerArea = document.querySelector('header.header');
;(headerArea || header).addEventListener('mouseleave', () => {
  if (panelHideTimer) clearTimeout(panelHideTimer);
  panelHideTimer = setTimeout(() => { panel.style.display = 'none'; }, 120);
});

/* ========= MOBILE DROPDOWN (no animation, correct same-item toggle) ========= */
const MOBILE_QUERY = '(max-width: 989px)';
const isMobile = () => window.matchMedia(MOBILE_QUERY).matches;

function normalizeLabel(s){
  return (s||'').toLowerCase().replace(/\s+/g,' ').trim();
}
function getTextOnly(node){
  let txt='';
  node.childNodes.forEach(n=>{
    if (n.nodeType===Node.TEXT_NODE) txt+=n.textContent;
    else if (n.nodeType===Node.ELEMENT_NODE && n.tagName==='SPAN') txt+=getTextOnly(n);
  });
  return txt.replace(/\s+/g,' ').trim();
}
function labelFrom(el){
  const span = el.querySelector('span');
  const raw  = span ? getTextOnly(span) : getTextOnly(el) || el.textContent || '';
  return raw.trim();
}
function itemsForLabel(label){
  const L = normalizeLabel(label);
  if (L==='instant top-up')    return (typeof instantItems  !== 'undefined' ? instantItems  : []) || [];
  if (L==='manual top-up')     return (typeof manualItems   !== 'undefined' ? manualItems   : []) || [];
  if (L==='accounts for sale') return (typeof accountsItems !== 'undefined' ? accountsItems : []) || [];
  return [];
}
function buildMobileGrid(container, items){
  container.innerHTML='';
  const grid=document.createElement('div');
  grid.className='mobile-grid';
  grid.style.display='grid';
  grid.style.gridTemplateColumns='repeat(2,1fr)';
  grid.style.gap='12px';

  items.slice().sort((a,b)=>(a.title||'').localeCompare(b.title||'')).forEach(item=>{
    const hasImg=!!item.image;
    const cell=document.createElement('div');
    cell.className='mobile-grid-cell';
    cell.style.display='flex';
    cell.style.alignItems='center';
    cell.style.paddingBottom='10px';
    cell.innerHTML=`
      <a href="${item.url}" class="mobile-product-link" style="display:flex;align-items:center;">
        ${hasImg ? `<img src="${item.image}" alt="${item.title||''}" style="width:40px;margin-right:8px;">` : ''}
        <span class="mobile-product-title">${item.title||''}</span>
      </a>`;
    grid.appendChild(cell);
  });
  container.appendChild(grid);
}

function onMobileParentTap(e){
  if (!isMobile()) return;

  // Only intercept taps on parent <summary> items
  const trigger = e.target.closest('nav.menu-drawer__navigation details > summary');
  if (!trigger) return;

  const label = labelFrom(trigger);
  const norm  = normalizeLabel(label);
  if (!['instant top-up','manual top-up','accounts for sale'].includes(norm)) return;

  // Beat the theme’s native behavior
  e.preventDefault();
  e.stopPropagation();
  if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

  const details = trigger.parentElement; // <details> element
  if (!details || details.tagName !== 'DETAILS') return;

  // Always keep the native <details> closed on mobile
  details.open = false;
  if (!details.__patchedToggle) {
    details.addEventListener('toggle', () => {
      if (isMobile()) details.open = false;
    });
    details.__patchedToggle = true;
  }

  // Create (and permanently bind) the custom panel to this <details>
  let panelEl = details.__mobilePanel;
  if (!panelEl) {
    panelEl = document.createElement('div');
    panelEl.className = 'mobile-panel';
    panelEl.style.display = 'none';
    // Insert right after the <details> node (sibling)
    details.parentElement.insertBefore(panelEl, details.nextSibling);
    // Build content once
    buildMobileGrid(panelEl, itemsForLabel(label));
    details.__mobilePanel = panelEl;
  }

  // If this panel is visible already, hide it (✅ same-item closes)
  const isVisible = panelEl.style.display === 'block';
  if (isVisible) {
    panelEl.style.display = 'none';
    return;
  }

  // Otherwise, hide all other custom panels, then show this one
  const drawerRoot = trigger.closest('nav.menu-drawer__navigation') || document;
  drawerRoot.querySelectorAll('.mobile-panel').forEach(p => {
    if (p !== panelEl) p.style.display = 'none';
  });
  panelEl.style.display = 'block';
}

// Attach early to win the event race with theme scripts
document.addEventListener('click', onMobileParentTap, true);
document.addEventListener('touchend', onMobileParentTap, { capture:true, passive:false });

// When leaving mobile, hide all custom panels
window.addEventListener('resize', () => {
  if (!isMobile()) {
    document.querySelectorAll('nav.menu-drawer__navigation .mobile-panel')
      .forEach(p => p.style.display='none');
  }
});
/* ======== end mobile block ======== */



    /*
| Add catalog link to product page
*/

    // Product title mapping to catalog links and URLs
    const productCatalogData = {
      "Honkai Star Rail Selective Starter Accounts": {
        text: "Click Here - Honkai Star Rail: Selective Starter Account Catalog",
        url: "http://chushi.jiankj.cn:81/Games/XQTD/index.php",
      },
      "Arknights Selective Starter Account": {
        text: "Click Here - Arknights: Selective Starter Account Catalog",
        url: "http://129.226.60.148/arknight-en/index.html",
      },
      "Pokémon TCG Pocket Selective Starter Accounts": {
        text: "Click Here - Pokémon TCG Pocket: Selective Starter Account Catalog 1",
        url: "http://chushi.jiankj.cn:81/games/ptcgp/index.php",
      },
      "NIKKE: Goddess of Victory Selective Starter Account": {
        text: "Click Here - NIKKE: Selective Starter Account Catalog",
        url: "http://my.jiankj.cn:81/Games/NIKKE/index.php",
      },
      "Raid Shadow Legends Selective Starter Accounts": {
        text: "Click Here: RSL Starter Accounts Catalog 1",
        url: "https://www.ak07.cn/game/",
      },
      "Epic Seven Selective Starter Accounts": {
        text: "Click Here: Epic Seven Starter Accounts Catalog 1",
        url: "http://show898.com/xk/gjdqn",
      },
      "Solo Leveling Selective Starter Accounts": {
        text: "Click Here: Solo Leveling Starter Accounts Catalog 1",
        url: "http://show898.com/xk/wdzsj",
        text2: "Click Here: Solo Leveling Starter Accounts Catalog 2",
        url2: "http://my.jiankj.cn:81/Games/SLA/index.php",
      },
      "Zenless Zone Zero Selective Starter Accounts": {
        text: "Click Here: Zenless Zone Zero Starter Account Catalog 1",
        url: "http://jdwlgame.com/zzz/",
      },
      "Wuthering Waves Selective Starter Accounts": {
        text: "Click Here: Wuthering Waves Starters Catalog 1",
        url: "http://jdwlgame.com/whglobal/",
        text2: "Click Here: Wuthering Waves Starters Catalog 2",
        url2: "http://bssy.top/index/mc/#account-search-href",
        text3: "Click Here: Wuthering Waves Starters Catalog 3",
        url3: "http://bssy.top/index/mc/#account-href",
      },
    };

    // Check if the page contains a recognized product title
    const productTitle = document.querySelector(".product__title h1");
    if (
      !productTitle ||
      !(productTitle.textContent.trim() in productCatalogData)
    ) {
      // console.warn("Product title does not match any known products: Script will not execute.");
      return;
    }

    // Add to Cart button selector
    const addToCartButton = document.querySelector(
      "#product-form-template--15271230570635__main button.product-form__submit"
    );

    if (addToCartButton) {
      if (
        productTitle.innerText === "Solo Leveling Selective Starter Accounts"
      ) {
        // Create the 1st link element
        const catalogLink1 = document.createElement("a");
        catalogLink1.href =
          productCatalogData[productTitle.textContent.trim()].url;
        catalogLink1.textContent =
          productCatalogData[productTitle.textContent.trim()].text;
        catalogLink1.target = "_blank";
        catalogLink1.style.display = "block";
        catalogLink1.style.color = "red";
        catalogLink1.style.fontSize = "26px";
        catalogLink1.style.fontWeight = "bold";
        catalogLink1.style.lineHeight = "35px";
        catalogLink1.style.textDecoration = "underline";
        catalogLink1.style.marginBottom = "10px";
        catalogLink1.style.paddingBottom = "10px";
        catalogLink1.style.textAlign = "left";

        // Insert the 1st link above the Add to Cart button
        addToCartButton.parentNode.insertBefore(catalogLink1, addToCartButton);

        // Create the 2nd link element
        const catalogLink2 = document.createElement("a");
        catalogLink2.href =
          productCatalogData[productTitle.textContent.trim()].url2;
        catalogLink2.textContent =
          productCatalogData[productTitle.textContent.trim()].text2;
        catalogLink2.target = "_blank";
        catalogLink2.style.display = "block";
        catalogLink2.style.color = "red";
        catalogLink2.style.fontSize = "26px";
        catalogLink2.style.fontWeight = "bold";
        catalogLink2.style.lineHeight = "35px";
        catalogLink2.style.textDecoration = "underline";
        catalogLink2.style.marginBottom = "10px";
        catalogLink2.style.paddingBottom = "10px";
        catalogLink2.style.textAlign = "left";

        // Insert the 2nd link above the Add to Cart button
        addToCartButton.parentNode.insertBefore(catalogLink2, addToCartButton);
        return;
      } else if (
        productTitle.innerText === "Wuthering Waves Selective Starter Accounts"
      ) {
        // Create the 1st link element
        const catalogLink1 = document.createElement("a");
        catalogLink1.href =
          productCatalogData[productTitle.textContent.trim()].url;
        catalogLink1.textContent =
          productCatalogData[productTitle.textContent.trim()].text;
        catalogLink1.target = "_blank";
        catalogLink1.style.display = "block";
        catalogLink1.style.color = "red";
        catalogLink1.style.fontSize = "26px";
        catalogLink1.style.fontWeight = "bold";
        catalogLink1.style.lineHeight = "35px";
        catalogLink1.style.textDecoration = "underline";
        catalogLink1.style.marginBottom = "10px";
        catalogLink1.style.paddingBottom = "10px";
        catalogLink1.style.textAlign = "left";

        // Insert the 1st link above the Add to Cart button
        addToCartButton.parentNode.insertBefore(catalogLink1, addToCartButton);

        // Create the 2nd link element
        const catalogLink2 = document.createElement("a");
        catalogLink2.href =
          productCatalogData[productTitle.textContent.trim()].url2;
        catalogLink2.textContent =
          productCatalogData[productTitle.textContent.trim()].text2;
        catalogLink2.target = "_blank";
        catalogLink2.style.display = "block";
        catalogLink2.style.color = "red";
        catalogLink2.style.fontSize = "26px";
        catalogLink2.style.fontWeight = "bold";
        catalogLink2.style.lineHeight = "35px";
        catalogLink2.style.textDecoration = "underline";
        catalogLink2.style.marginBottom = "10px";
        catalogLink2.style.paddingBottom = "10px";
        catalogLink2.style.textAlign = "left";

        // Insert the 2nd link above the Add to Cart button
        addToCartButton.parentNode.insertBefore(catalogLink2, addToCartButton);

        // Create the 3rd link element
        const catalogLink3 = document.createElement("a");
        catalogLink3.href =
          productCatalogData[productTitle.textContent.trim()].url3;
        catalogLink3.textContent =
          productCatalogData[productTitle.textContent.trim()].text3;
        catalogLink3.target = "_blank";
        catalogLink3.style.display = "block";
        catalogLink3.style.color = "red";
        catalogLink3.style.fontSize = "26px";
        catalogLink3.style.fontWeight = "bold";
        catalogLink3.style.lineHeight = "35px";
        catalogLink3.style.textDecoration = "underline";
        catalogLink3.style.marginBottom = "10px";
        catalogLink3.style.paddingBottom = "10px";
        catalogLink3.style.textAlign = "left";

        // Insert the 3rd link above the Add to Cart button
        addToCartButton.parentNode.insertBefore(catalogLink3, addToCartButton);
        return;
      }
      // Create the link element
      const catalogLink1 = document.createElement("a");
      catalogLink1.href =
        productCatalogData[productTitle.textContent.trim()].url;
      catalogLink1.textContent =
        productCatalogData[productTitle.textContent.trim()].text;
      catalogLink1.target = "_blank";
      catalogLink1.style.display = "block";
      catalogLink1.style.color = "red";
      catalogLink1.style.fontSize = "26px";
      catalogLink1.style.fontWeight = "bold";
      catalogLink1.style.lineHeight = "35px";
      catalogLink1.style.textDecoration = "underline";
      catalogLink1.style.marginBottom = "10px";
      catalogLink1.style.paddingBottom = "10px";
      catalogLink1.style.textAlign = "left";

      // Insert the link above the Add to Cart button
      addToCartButton.parentNode.insertBefore(catalogLink1, addToCartButton);
    }
  },
  false
);
